module.exports = __webpack_public_path__ + "f1e24b3951e44ab63565cb952c2eab2d.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_bar_1month_show_labels.png
// module id = 861
// module chunks = 7